import CloseIcon from '@mui/icons-material/Close';
import { memo, cloneElement, ReactNode } from 'react';
import { AgColor } from '../../Styles/AgColor';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AgTypography from '../../Styles/AgTypography';
import IconButton from '@mui/material/IconButton';

export interface AgAlertProps {
  severity: 'success' | 'error' | 'neutral';
  message: string | ReactNode;
  temporary?: boolean;
  onIconClick?: () => void;
}

const AgAlert = ({ severity = 'success', message, temporary = false, onIconClick }: AgAlertProps) => {
  const colorIconMapping = {
    success: {
      color: AgColor.success2,
      icon: <CheckCircleOutlineOutlinedIcon />
    },
    neutral: {
      color: AgColor.link1,
      icon: <ErrorOutlineOutlinedIcon />
    },
    error: {
      color: AgColor.errorMain,
      icon: <WarningAmberOutlinedIcon />
    }
  };
  
  const colorIcon = colorIconMapping[severity];

  return (
    <AgTypography
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        color: AgColor.grey0,
        padding: '12px 0',
        gap: '12px',
        backgroundColor: colorIcon.color,
        borderRadius: '4px',
        boxShadow: 'none'
      }}
    >
      {cloneElement(colorIcon.icon, { style: { marginLeft: '16px' } })}
      <AgTypography
        contentStyle={'AP.Paragraph.Large.SemiBold'}
        style={{
          whiteSpace: 'pre-line',
          wordWrap: 'break-word',
          width: '100%',
          color: AgColor.grey0,
          marginRight: temporary ? '16px' : 0
        }}>
        {message}
      </AgTypography>
      {!temporary && <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={onIconClick}
        sx={{
          marginRight: '16px'
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>}
    </AgTypography>
  );
};

export default memo(AgAlert);